module.exports = __webpack_public_path__ + "img/coupon.1292fc02.svg";